import React from "react";

const MapMarker = () => {
  return (
    <svg
      width="38"
      height="52"
      viewBox="0 0 38 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.625 50.1458C11.4792 43.7135 0 28.375 0 19.6667C0 9.17709 8.41146 0.666669 19 0.666669C29.4896 0.666669 38 9.17709 38 19.6667C38 28.375 26.4219 43.7135 21.276 50.1458C20.0885 51.6302 17.8125 51.6302 16.625 50.1458ZM19 26C22.4635 26 25.3333 23.2292 25.3333 19.6667C25.3333 16.2031 22.4635 13.3333 19 13.3333C15.4375 13.3333 12.6667 16.2031 12.6667 19.6667C12.6667 23.2292 15.4375 26 19 26Z"
        fill="#66FA93"
      />
    </svg>
  );
};

export default MapMarker;
